// breakpoint where swiper will be destroyed
// and switches to a dual-column layout
export const breakpoint = window.matchMedia('(min-width:768px)');

